import { useSnackbar } from "notistack";
import { useState } from "react";

import { PropallyApiFactory } from "../../../../module/custom_api_factory";

export const useSendPasswordResetLink = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const fp = PropallyApiFactory();

  const sendPasswordResetLink = async (data: { email: string }) => {
    try {
      setError("");
      setLoading(true);
      await fp.v1PasswordResetsPost(data);

      enqueueSnackbar(
        "ご記入のメールアドレスにパスワードリセットのリンクを送信しました。メールが届かない場合は、迷惑メールボックスもご確認ください。それでもメールが見つからない場合は、メールアドレスに誤りがあり送付が出来ていない可能性がございますので、もう一度パスワードリセットをお試しください。",
        { autoHideDuration: 5000 }
      );
    } catch (e) {
      if (e.response?.status === 404) {
        setError("アカウントが見つかりません");
      }

      setError("ネットワークエラーです。しばらくたってからお試しください");
    } finally {
      setLoading(false);
    }
  };

  return { sendPasswordResetLink, loading, error };
};

export const useResetPassword = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const fp = PropallyApiFactory();

  const resetPassword = async (data: { password: string; password_confirmation: string }) => {
    const params = new URLSearchParams(location.search.substring(1));
    const password_reset_token = params.get("prt");

    try {
      setError("");
      setLoading(true);
      await fp.v1NewPasswordsPost({
        ...data,
        password_reset_token: password_reset_token,
      });
      enqueueSnackbar("パスワードリセットに成功しました。新しいパスワードでもう一度ログインしてください", {
        autoHideDuration: 5000,
      });
    } catch (e) {
      if (e.response?.status === 404) {
        setError("通信に失敗しました。もう一度やり直してください");
      } else if (e.response?.status === 422) {
        setError("パスワード変更に失敗しました。入力内容を確認してください");
      } else {
        setError("ネットワークエラーです。しばらくたってからお試しください");
      }
    } finally {
      setLoading(false);
    }
  };

  return { resetPassword, loading, error };
};
